import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
import { courseQueryOptions } from "../../../api/useCourse";
import { categorySearchSchema } from "../../../helpers/search.helpers";
import CoursePage from "../../../pages/CoursePage/CoursePage";

export const Route = createFileRoute(
  "/(app)/courses_/$type/$publicCourseUuid/"
)({
  component: RouteComponent,
  loader: ({ params, context }) =>
    context.queryClient.ensureQueryData(
      courseQueryOptions(params.publicCourseUuid)
    ),
  validateSearch: zodValidator(
    categorySearchSchema.extend({
      o: fallback(z.string().optional(), undefined),
    })
  ),
});

function RouteComponent() {
  const { publicCourseUuid } = Route.useParams();
  const { data } = useSuspenseQuery(courseQueryOptions(publicCourseUuid));
  return <CoursePage course={data} />;
}
